import { render, staticRenderFns } from "./FooterAlt.vue?vue&type=template&id=0d2d2b97"
import script from "./FooterAlt.vue?vue&type=script&lang=js"
export * from "./FooterAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2d2b97')) {
      api.createRecord('0d2d2b97', component.options)
    } else {
      api.reload('0d2d2b97', component.options)
    }
    module.hot.accept("./FooterAlt.vue?vue&type=template&id=0d2d2b97", function () {
      api.rerender('0d2d2b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/FooterAlt.vue"
export default component.exports